import { useState } from 'react'
import { Link } from 'react-router-dom'
import { authService } from '../services/authService'
import { useTranslation } from '../contexts/TranslationContext'

export default function ForgotPassword() {
  const { t } = useTranslation()
  const [email, setEmail] = useState('')
  const [message, setMessage] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = async (e) => {
    e.preventDefault()

    try {
      const response = await authService.requestPasswordReset(email)
      setMessage(response.message || t('Password reset email sent', 'Password reset email sent'))
      setError('')
    } catch (err) {
      setError(err.response?.data?.message || t('Could not send reset email', 'Could not send reset email'))
      setMessage('')
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-surface rounded-lg shadow-lg p-8">
        <h2 className="text-2xl font-bold mb-4">{t('Forgot Password', 'Forgot Password')}</h2>
        <p className="text-sm text-muted-foreground mb-6">
          {t('Enter your email to receive a password reset link.', 'Enter your email to receive a password reset link.')}
        </p>

        {message && <div className="mb-4 text-green-700 bg-green-100 border border-green-200 p-3 rounded">{message}</div>}
        {error && <div className="mb-4 text-red-700 bg-red-100 border border-red-200 p-3 rounded">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-foreground">{t('Email', 'Email')}</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 w-full border-outline rounded-md shadow-sm focus:ring-blue-500 focus:border-blue-500"
              required
            />
          </div>
          <button type="submit" className="w-full bg-blue-600 hover:bg-blue-700 text-white py-2 rounded">
            {t('Send Reset Link', 'Send Reset Link')}
          </button>
        </form>
        <p className="mt-4 text-sm text-muted-foreground">
          <Link to="/login" className="text-blue-600 hover:underline">{t('Back to login', 'Back to login')}</Link>
        </p>
      </div>
    </div>
  )
}

